import parseIsoDuration from 'parse-iso-duration'

export function durationToMinutes (value: string): number {
  return Math.round(parseIsoDuration(value) / (60 * 1000))
}
